import { motion } from "framer-motion";
import { Circle, Zap, Bike, Grid3X3, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { ProductTypeFilter as FilterType, productTypeFilters } from "@/data/productLines";

const iconMap: Record<string, LucideIcon> = {
  Circle,
  Zap,
  Bike,
  Grid3X3,
};

interface ProductTypeFilterProps {
  activeFilter: string;
  onFilterChange: (filterId: string) => void;
  productCounts: Record<string, number>;
}

const ProductTypeFilterComponent = ({ 
  activeFilter, 
  onFilterChange, 
  productCounts 
}: ProductTypeFilterProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-8">
      {productTypeFilters.map((filter) => {
        const Icon = iconMap[filter.icon] || Grid3X3;
        const isActive = activeFilter === filter.id;
        const count = filter.id === "all" 
          ? Object.values(productCounts).reduce((a, b) => a + b, 0)
          : productCounts[filter.id] || 0;

        return (
          <motion.button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              "relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all",
              "border backdrop-blur-sm",
              isActive
                ? "bg-primary text-primary-foreground border-primary shadow-lg shadow-primary/20"
                : "bg-card/50 border-border/50 text-muted-foreground hover:bg-card hover:text-foreground hover:border-primary/30"
            )}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Icon className="w-4 h-4" />
            <span>{filter.name}</span>
            <span className={cn(
              "ml-1 px-2 py-0.5 rounded-full text-xs",
              isActive
                ? "bg-primary-foreground/20 text-primary-foreground"
                : "bg-muted text-muted-foreground"
            )}>
              {count}
            </span>
          </motion.button>
        );
      })}
    </div>
  );
};

export default ProductTypeFilterComponent;
